import React, { ReactNode } from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  Slide,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { TransitionProps } from "@mui/material/transitions";
import Button from "../Button/Button";

interface ConfirmationDialogProps {
  open?: boolean;
  loading?: boolean;
  title: string;
  summary: string | ReactNode;
  onClose?: () => void;
  onConfirm?: () => void;
}

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const ConfirmationDialog: React.FC<ConfirmationDialogProps> = ({
  open = false,
  loading = false,
  onClose,
  onConfirm,
  title,
  summary,
}) => {
  return (
    <Dialog
      maxWidth={"sm"}
      fullWidth
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          overflow: "visible",
          borderRadius: "15px",
          
        },
      }}
    >
      <DialogTitle
        sx={{
          borderBottom: "solid 1px #ddd",
          position: "relative",
          fontSize: {xs: "1rem", md: "1.25rem"}
        }}
      >
        {title}
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: {xs: "-15px", md: "-20px"},
            top: {xs: "-15px", md: "-20px"},
            height: {xs: "34px", md: "44px"},
            width: {xs: "34px", md: "44px"},
            color: "#FB8B0E",
            border: "2px solid #FB8B0E",
            borderRadius: "50% !important",
            padding: 0,
            backgroundColor: "#fff",
            zIndex: 1000,
          }}
          disableRipple
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          maxHeight: "200px",
        }}
      >
        <DialogContentText
          sx={{
            marginTop: {xs: "1rem", md: "2rem"},
            color: "#202224",
            fontSize: {xs: "14px", md: "18px"},
          }}
        >
          {summary}
        </DialogContentText>
      </DialogContent>
      <DialogActions
        sx={{
          padding: {xs: "1rem", md: "1.5rem"},
        }}
      >
        <Button
          onClick={onClose}
          variant="secondary"
          variantType="outlined"
          label="No"
          style={{
            marginRight: "10px",
          }}
        />
        <Button
          isLoading={loading}
          onClick={onConfirm}
          variant="secondary"
          variantType="contained"
          label="Yes"
        />
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationDialog;
